import { createContext } from 'react';
const LocaleContext = createContext(undefined);
export default LocaleContext;
